let globalListenersBound = false
const MAX_PEOPLE = 6
const MIN_ADULTS = 1

function guestPickers() {
  return [...document.querySelectorAll("[data-search-bar-guests]")]
}

function closePicker(picker) {
  const panel = picker.querySelector("[data-search-bar-guests-panel]")
  const toggle = picker.querySelector("[data-search-bar-guests-toggle]")

  picker.classList.remove("is-open")
  panel?.setAttribute("hidden", "")
  toggle?.setAttribute("aria-expanded", "false")
}

function closeOtherPickers(currentPicker) {
  guestPickers().forEach((picker) => {
    if (picker !== currentPicker) {
      closePicker(picker)
    }
  })
}

function closePickersOutside(target) {
  guestPickers().forEach((picker) => {
    if (!picker.contains(target)) {
      closePicker(picker)
    }
  })
}

function togglePicker(picker) {
  const panel = picker.querySelector("[data-search-bar-guests-panel]")
  const toggle = picker.querySelector("[data-search-bar-guests-toggle]")
  const isOpening = panel?.hasAttribute("hidden")

  if (isOpening) {
    closeOtherPickers(picker)
    picker.classList.add("is-open")
    panel?.removeAttribute("hidden")
    toggle?.setAttribute("aria-expanded", "true")
    return
  }

  closePicker(picker)
}

function selectedGuests(picker) {
  return [...picker.querySelectorAll("[data-search-bar-guest-select]")].map((select) => ({
    value: parseInt(select.value || "0", 10),
    singular: select.dataset.guestSingular,
    plural: select.dataset.guestPlural,
  }))
}

function guestSelect(picker, name) {
  return picker.querySelector(`[name="${name}"]`)
}

function dogFriendlyToggle(picker) {
  return picker.querySelector("[data-search-bar-dog-friendly-toggle]")
}

function clampNumber(value, min, max, fallback = min) {
  const number = parseInt(value, 10)

  if (Number.isNaN(number)) {
    return fallback
  }

  return Math.min(max, Math.max(min, number))
}

function updateSelectBounds(select, min, max) {
  if (!select) {
    return
  }

  ;[...select.options].forEach((option) => {
    const value = parseInt(option.value, 10)

    option.disabled = Number.isNaN(value) || value < min || value > max
  })
}

function setSelectValue(select, value) {
  if (!select || select.value === String(value)) {
    return false
  }

  select.value = String(value)
  return true
}

function normalizePicker(picker) {
  const adultsSelect = guestSelect(picker, "no_of_adults")
  const kidsSelect = guestSelect(picker, "no_of_children")

  updateSelectBounds(adultsSelect, MIN_ADULTS, MAX_PEOPLE)

  const adults = clampNumber(adultsSelect?.value, MIN_ADULTS, MAX_PEOPLE, MIN_ADULTS)
  setSelectValue(adultsSelect, adults)

  const maxKids = Math.max(0, MAX_PEOPLE - adults)
  updateSelectBounds(kidsSelect, 0, maxKids)
  setSelectValue(kidsSelect, clampNumber(kidsSelect?.value, 0, maxKids, 0))

  updateSummary(picker)
}

function desktopSummary(guests) {
  const parts = guests
    .filter((guest) => guest.value > 0)
    .map((guest) => `${guest.value} ${guest.value === 1 ? guest.singular : guest.plural}`)

  return parts.length ? parts.join(", ") : "Guests"
}

function updateSummary(picker) {
  const summary = picker.querySelector("[data-search-bar-guests-summary]")

  if (!summary) {
    return
  }

  const guests = selectedGuests(picker)
  const dogFriendly = dogFriendlyToggle(picker)?.checked === true
  const guestSummary = desktopSummary(guests)

  summary.textContent = dogFriendly && guestSummary !== "Guests"
    ? `${guestSummary}, Dog friendly`
    : dogFriendly
      ? "Dog friendly"
      : guestSummary
}

function initPicker(picker) {
  if (picker.dataset.searchBarGuestsInitialized === "true") {
    normalizePicker(picker)
    return
  }

  picker.dataset.searchBarGuestsInitialized = "true"

  picker.querySelector("[data-search-bar-guests-toggle]")?.addEventListener("click", () => {
    togglePicker(picker)
  })

  picker.querySelectorAll("[data-search-bar-guest-select]").forEach((select) => {
    select.addEventListener("change", () => normalizePicker(picker))
  })

  dogFriendlyToggle(picker)?.addEventListener("change", () => updateSummary(picker))

  normalizePicker(picker)
}

function bindGlobalListeners() {
  if (globalListenersBound) {
    return
  }

  globalListenersBound = true

  document.addEventListener("pointerdown", (event) => {
    closePickersOutside(event.target)
  }, { capture: true })

  document.addEventListener("focusin", (event) => {
    closePickersOutside(event.target)
  })

  document.addEventListener("change", (event) => {
    closePickersOutside(event.target)
  })

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      guestPickers().forEach(closePicker)
    }
  })

  window.addEventListener("resize", () => {
    guestPickers().forEach(updateSummary)
  })

  window.addEventListener("livewire:navigated", () => {
    initSearchBarGuests()
  })

  window.addEventListener("search-bar-guests:normalize", () => {
    initSearchBarGuests()
  })
}

export default function initSearchBarGuests() {
  bindGlobalListeners()
  guestPickers().forEach(initPicker)
}
